// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
// import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import { ReactComponent as CopyIcon } from "../../../../../assets/svgs/file-icon.svg";
// import { useNavigate } from "react-router-dom";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import CopyForm from "./CopyForm";
// import { toast } from "react-hot-toast";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// const StandardForm = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedForm, setSelectedForm] = useState(null);
//   const [openCopyForm, setOpenCopyForm] = useState(false);
//   const navigate = useNavigate();

//   const fetchForms = useCallback(
//     async (page = currentPage, size = pageSize, searchTerm) => {
//       try {
//         const response = await getApi({
//           apiUrl: API_URLS.GET_STANDARDFORMS(page, size, searchTerm),
//         });
//         if (response.success) {
//           setCurrentPage(response.data.metadata.currentPage);
//           setTotalRecords(response.data.metadata.totalRecords);
//           setPageSize(response.data.metadata.resultsPerPage);

//           const formattedData = response.data.data.map((item, index) => ({
//             key: item._id,
//             serial: index + 1,
//             formName: item.title,
//             assignedOn: new Date(item.createdAt).toLocaleDateString(),
//             action: (
//               <div className="flex gap-3">
//                 <EyeIcon
//                   style={{ fontSize: "18px", cursor: "pointer" }}
//                   onClick={() =>
//                     navigate(
//                       `/organization/projects/standard-forms/view/${item._id}`,
//                     )
//                   }
//                 />
//                 <CopyIcon
//                   style={{ fontSize: "18px", cursor: "pointer" }}
//                   onClick={() => {
//                     setOpenCopyForm(true);
//                     setSelectedForm(item);
//                   }}
//                 />
//               </div>
//             ),
//           }));

//           setTableData(formattedData);
//           setFilteredData(formattedData);
//         }
//       } catch (error) {
//         console.error("Failed to fetch standard forms:", error);
//         toast.error("Error fetching standard forms.");
//       }
//     },
//     [navigate, currentPage, pageSize],
//   );

//   useEffect(() => {
//     fetchForms(currentPage, pageSize, searchTerm);
//   }, [searchTerm]);

//   const handlePageChange = useCallback(
//     (page) => {
//       setCurrentPage(page);
//       fetchForms(page, pageSize, searchTerm);
//     },
//     [fetchForms, pageSize],
//   );

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Form Name", key: "formName" },
//       { label: "Assigned On", key: "assignedOn" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const handleSearch = useCallback((searchTerm) => {
//     setSearchTerm(searchTerm);
//   });

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div>
//         {/* Breadcrumb */}
//         <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2">
//           <p>Home</p>
//           <span>/</span>
//           <p>Project</p>
//           <span>/</span>
//           <TextStyles style={{ color: "#06513D" }}>Standard Form</TextStyles>
//         </div>

//         {/* Title & Back Icon */}
//         <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//           <IoArrowBackCircleOutline className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" />
//           <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//             Standard Form
//           </div>
//         </div>

//         {/* Main Card */}
//         <div className="border border-[#3BA2B959] rounded-xl pt-5 sm:pt-6 pb-4 bg-white shadow-md">
//           {/* Header Section */}
//           <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 px-4 sm:px-6 mb-4">
//             {/* Total Forms */}
//             <div className="sm:w-1/2 lg:w-auto px-3 py-2 border border-[#06513D] rounded-md bg-[#B6D4D933] text-[#005E45] text-sm font-light font-[Calibri] text-center sm:text-left">
//               TOTAL STANDARD FORMS {tableData.length}
//             </div>

//             {/* Search */}
//             <div className="sm:w-1/2 lg:w-[300px] mt-2 sm:mt-0">
//               <SearchBar width="100%" onSearch={handleSearch} />
//             </div>
//           </div>

//           {/* Table */}
//           <div className="overflow-x-auto px-2">
//             <Tables
//               data={filteredData}
//               headers={headers}
//               onChange={handlePageChange}
//               pageSize={pageSize}
//               current={currentPage}
//               total={totalRecords}
//             />
//           </div>
//         </div>

//         {/* Copy Form Modal */}
//         {openCopyForm && (
//           <CopyForm
//             onOpen={openCopyForm}
//             onClose={() => setOpenCopyForm(false)}
//             data={selectedForm}
//             onSave={async () => {
//               await fetchForms();
//               setOpenCopyForm(false);
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default StandardForm;

import React, { useState, useEffect, useMemo, useCallback } from "react";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as CopyIcon } from "../../../../../assets/svgs/file-icon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import CopyForm from "./CopyForm";
import { toast } from "react-hot-toast";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import PopupCard from "../../../../Auth/PopupCard";
import PermissionForm from "../../../../Auth/PermissionForm";
import { useSelector } from "react-redux";
import useDebounce from "../../../../../hooks/debouncing";
const StandardForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(
    location.state?.standardFormSearch || "",
  );
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    location.state?.standardFormPage || 1,
  );

  useEffect(() => {
    if (
      location.state?.standardFormPage !== currentPage ||
      location.state?.standardFormSearch !== searchTerm
    ) {
      navigate(".", {
        replace: true,
        state: {
          ...location.state,
          standardFormPage: currentPage,
          standardFormSearch: searchTerm,
        },
      });
    }
  }, [currentPage, searchTerm, navigate, location.state]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [openCopyForm, setOpenCopyForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const debouncedSearch = useDebounce(searchTerm, 500);
  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  console.log(user, "useruseruseruser in standard form");
  const isPermissionCompleted = user?.isCompleted;

  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Derive correct clientId: for sub-admins, client_id is nested object
  const clientId = user?.client_id?._id || user?._id;

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  const fetchForms = useCallback(
    async (page = currentPage, size = pageSize, debouncedSearch) => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARDFORMS(
            clientId,
            page,
            size,
            debouncedSearch,
          ),
        });
        if (response.success) {
          setCurrentPage(response.data.metadata.currentPage);
          setTotalRecords(response.data.metadata.totalRecords);
          setPageSize(response.data.metadata.resultsPerPage);
          const current = response.data.metadata.currentPage;
          const resultsPerPage = response.data.metadata.resultsPerPage;
          const formattedData = response.data.data.map((item, index) => ({
            key: item._id,
            serial: (
              <div className="text-center" title="">
                {(current - 1) * resultsPerPage + index + 1}
              </div>
            ),
            formName: (
              <div className="text-center" title="">
                {item.title}
              </div>
            ),
            // assignedOn: (
            //   <div className="text-center" title="">
            //     {" "}
            //     {new Date(item.createdAt).toLocaleDateString()}
            //   </div>
            // ),
            action: (
              <div
                className="flex gap-1 sm:gap-2 items-center justify-center"
                title=""
              >
                <EyeIcon
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => handleNavigate(item)}
                />
                {/* <CopyIcon
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => {
                    setOpenCopyForm(true);
                    setSelectedForm(item);
                  }}
                /> */}
              </div>
            ),
            // Store original item data for mobile cards
            originalItem: item,
          }));

          setTableData(formattedData);
          setFilteredData(formattedData);
        }
      } catch (error) {
        console.error("Failed to fetch standard forms:", error);
        toast.error("Error fetching standard forms.");
      }
    },
    [navigate, currentPage, pageSize],
  );

  const triggerPopup = (type, title, message) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
  };

  useEffect(() => {
    fetchForms(currentPage, pageSize, debouncedSearch);
  }, [debouncedSearch]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      fetchForms(page, pageSize, debouncedSearch);
    },
    [fetchForms, pageSize],
  );

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Name", key: "formName" },
      // { label: "Assigned On", key: "assignedOn" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const handleSearch = useCallback((searchTerm) => {
    setSearchTerm(searchTerm);
    setCurrentPage(1);
  });

  const handleNavigate = (item) => {
    console.log("item.title item.title", item.title);

    if (item.viewStatus) {
      if (item.title) {
        navigate(`/organization/projects/standard-forms/action/${item._id}`, {
          state: {
            formName: item.title,
          },
        });
      } else {
        navigate(`/organization/projects/standard-forms/action/${item._id}`);
      }
    } else {
      triggerPopup(
        "error",
        "Error",
        `You do not have the required permission to view or access this form. Please get in touch with the OffsetGo Support Team.\n \n📞 1800 572 2929 ✉️ carburn@offsetgo.earth`,
      );
    }
  };

  // Mobile Card Component
  const MobileCard = ({ item, index }) => (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <div className="text-xs text-gray-500 mb-1">#{item.serial}</div>
          <div className="font-medium text-gray-900 text-sm leading-tight">
            {item.formName}
          </div>
        </div>
        <div className="flex gap-3 ml-3">
          <EyeIcon
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => handleNavigate(item.originalItem)}
          />
          {/* <CopyIcon
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => {
              setOpenCopyForm(true);
              setSelectedForm(item.originalItem);
            }}
          /> */}
        </div>
      </div>
      <div className="text-xs text-gray-600">
        <span className="font-medium">Assigned On: </span>
        {item.assignedOn}
      </div>
    </div>
  );

  // Pagination component for mobile
  const MobilePagination = () => {
    const totalPages = Math.ceil(totalRecords / pageSize);

    return (
      <div className="flex justify-between items-center mt-4 px-2">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-sm bg-gray-100 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>
        <span className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 text-sm bg-gray-100 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}

      <div>
        {/* Breadcrumb */}
        <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <p>Project</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>Standard Form</TextStyles>
        </div>

        {/* Title & Back Icon */}
        <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          {/* <IoArrowBackCircleOutline className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" /> */}
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Standard Form
          </div>
        </div>

        {/* Main Card */}
        <div className="overflow-hidden border border-[#3BA2B959] rounded-xl pt-5 sm:pt-6 pb-4 bg-white shadow-md">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 px-4 sm:px-6 mb-4">
            {/* Total Forms */}
            <div className="sm:w-1/2 lg:w-auto px-3 py-2 border border-[#06513D] rounded-md bg-[#B6D4D933] text-[#005E45] text-sm font-light font-[Calibri] text-center sm:text-left">
              TOTAL STANDARD FORMS {tableData.length}
            </div>

            {/* Search */}
            <div className="sm:w-1/2 lg:w-[300px] mt-2 sm:mt-0">
              <SearchBar width="100%" onSearch={handleSearch} />
            </div>
          </div>

          {/* Mobile View - Cards */}
          <div className="block sm:hidden px-2">
            {filteredData.map((item, index) => (
              <MobileCard key={item.key} item={item} index={index} />
            ))}
            {filteredData.length > 0 && <MobilePagination />}
          </div>

          {/* Desktop/Tablet View - Table */}
          <div className="hidden sm:block overflow-x-auto px-2">
            <Tables
              data={filteredData}
              headers={headers}
              onChange={handlePageChange}
              pageSize={pageSize}
              current={currentPage}
              total={totalRecords}
            />
          </div>
        </div>

        {/* Copy Form Modal */}
        {/* {openCopyForm && (
          <CopyForm
            onOpen={openCopyForm}
            onClose={() => setOpenCopyForm(false)}
            data={selectedForm}
            onSave={async () => {
              await fetchForms();
              setOpenCopyForm(false);
            }}
          />
        )} */}
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
              onConfirm={() => setShowPopup(false)}
              confirmText="OK"
              widthClass="sm:w-[420px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StandardForm;
